// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"338":"665ff88d","493":"5e8ecde9","994":"30c66aa9"}[chunkId] + ".chunk.css";
};